import React from 'react';
import {useNavigate} from 'react-router-dom';

import NewsList from '../components/NewsList';
import {newsItems} from '../content/news/newsItems';
import {newsImageMap} from '../content/news/newsImages';
import SocialLinks from '../components/SocialLinks';
import './News.css';

function News() {
  let navigate = useNavigate();
  return (
    <div className='News'>
      <div className='newspage'>
        <h1 className='text-center'>NEWS</h1>
        <div className='newsletterPromo text-center my-4'>
          <p>
            {' '}
            Would you like to be amongst the first to get the latest updates?
          </p>

          <button
            onClick={() => navigate('/newsletter')}
            className='btnLightDark px-3 py-1'>
            Join the newsletter
          </button>
        </div>

        {/*  NEWSSSSS */}
        <hr />
        <NewsList
          items={newsItems}
          imageMap={newsImageMap}
          mode='full'
        />

        <SocialLinks />
      </div>
    </div>
  );
}

export default News;
